/* ==========================================================================
   SeedSwim — comportamiento del escaparate
   Sin dependencias. Se auto-inicializa y es seguro cargarlo varias veces.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__seedswimInit) return;
  window.__seedswimInit = true;

  var money = { format: '{{amount_with_comma_separator}} €' };

  /* ---------- utilidades ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    var fmt = format || money.format;
    var value = (cents / 100);
    function withComma(n, decimals) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return parts.join(',');
    }
    function withDot(n, decimals) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    return fmt
      .replace('{{amount_with_comma_separator}}', withComma(value, 2))
      .replace('{{amount_no_decimals_with_comma_separator}}', withComma(value, 0))
      .replace('{{amount}}', withDot(value, 2))
      .replace('{{amount_no_decimals}}', withDot(value, 0));
  }

  /* ---------- galería de producto ---------- */
  function initGallery(root) {
    if (root.dataset.ssReady) return;
    root.dataset.ssReady = '1';
    var slides = $$('[data-ss-slide]', root);
    var thumbs = $$('[data-ss-thumb]', root);

    function show(index) {
      slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.ssSlide === String(index)); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.ssThumb === String(index)); });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(t.dataset.ssThumb); });
    });

    root.addEventListener('ss:media', function (e) {
      if (e.detail && e.detail.mediaId) {
        var match = thumbs.filter(function (t) { return t.dataset.ssMediaId === String(e.detail.mediaId); })[0];
        if (match) show(match.dataset.ssThumb);
      }
    });
  }

  /* ---------- selector de variantes + precio + carrito ---------- */
  function initProductForm(root) {
    if (root.dataset.ssReady) return;
    root.dataset.ssReady = '1';

    var booted = false;
    var dataEl = $('[data-ss-variants]', root);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var moneyFormat = root.dataset.ssMoneyFormat || money.format;
    var idInput = $('[data-ss-variant-id]', root);
    var priceNow = $('[data-ss-price-now]', root);
    var priceWas = $('[data-ss-price-was]', root);
    var priceSave = $('[data-ss-price-save]', root);
    var submit = $('[data-ss-submit]', root);
    var gallery = $('[data-ss-gallery]');
    var stickyPrice = $('[data-ss-sticky-price]');
    var textSoldOut = root.dataset.ssSoldout || 'Agotado';
    var textAdd = root.dataset.ssAdd || 'Añadir al carrito';

    function selectedOptions() {
      return $$('[data-ss-option]', root).map(function (group) {
        var checked = $('input:checked', group);
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      return variants.filter(function (v) {
        return opts.every(function (val, i) { return val === null || v.options[i] === val; });
      })[0];
    }

    // Las etiquetas se resuelven una sola vez y se guardan en el propio input:
    // antes se hacía un querySelector por input en cada render (cada cambio de
    // opción y cada cambio de cantidad).
    function labelFor(group, input) {
      if (!input._ssLabel) input._ssLabel = group.querySelector('label[for="' + input.id + '"]');
      return input._ssLabel;
    }

    function updateOptionAvailability(opts) {
      $$('[data-ss-option]', root).forEach(function (group, gIndex) {
        $$('input', group).forEach(function (input) {
          var test = opts.slice();
          test[gIndex] = input.value;
          var candidates = variants.filter(function (v) {
            return test.every(function (val, i) { return val === null || v.options[i] === val; });
          });
          var available = candidates.some(function (v) { return v.available; });
          var label = labelFor(group, input);
          if (label) label.classList.toggle('is-soldout', !available && candidates.length > 0);
        });
      });
    }

    function render() {
      var opts = selectedOptions();
      var variant = findVariant(opts);
      updateOptionAvailability(opts);

      $$('[data-ss-option-selected]', root).forEach(function (el, i) {
        el.textContent = opts[i] || '';
      });

      if (!variant) {
        if (submit) { submit.disabled = true; submit.textContent = textSoldOut; }
        return;
      }

      if (idInput) idInput.value = variant.id;

      // El bloque de precio muestra siempre el precio estándar de 1 unidad
      if (priceNow) priceNow.textContent = formatMoney(variant.price, moneyFormat);
      if (priceWas) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWas.textContent = formatMoney(variant.compare_at_price, moneyFormat);
          priceWas.classList.remove('ss-hidden');
          if (priceSave) {
            var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
            priceSave.textContent = '-' + pct + '%';
            priceSave.classList.remove('ss-hidden');
          }
        } else {
          priceWas.classList.add('ss-hidden');
          if (priceSave) priceSave.classList.add('ss-hidden');
        }
      }

      // Precios por pack — debe coincidir con los descuentos automáticos del admin:
      // 2+ unidades -> 15%, 3+ unidades -> 20%.
      // Shopify redondea el importe del descuento hacia abajo al céntimo.
      $$('[data-ss-pack-price]', root).forEach(function (el) {
        var n = parseInt(el.getAttribute('data-ss-pack-price'), 10) || 1;
        var rate = 0;
        if (n >= 3) rate = 0.20;
        else if (n >= 2) rate = 0.15;
        var base = variant.price * n;
        var total = base - Math.floor(base * rate);
        var nowEl = $('[data-ss-pack-now]', el);
        var wasEl = $('[data-ss-pack-was]', el);
        if (nowEl) nowEl.textContent = formatMoney(total, moneyFormat);
        if (wasEl) wasEl.textContent = formatMoney(base, moneyFormat);
      });
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price, moneyFormat);

      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? textAdd : textSoldOut;
      }

      if (gallery && variant.featured_media_id) {
        gallery.dispatchEvent(new CustomEvent('ss:media', { detail: { mediaId: variant.featured_media_id } }));
      }

      // La URL sólo se reescribe cuando el usuario cambia de variante, no en el
      // arranque: antes se hacía también al cargar, sin ninguna interacción.
      if (booted && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    $$('[data-ss-option] input', root).forEach(function (input) {
      input.addEventListener('change', render);
    });

    // cantidad
    $$('[data-ss-qty]', root).forEach(function (wrap) {
      var input = $('[data-ss-qty-input]', wrap);
      $$('[data-ss-qty-step]', wrap).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.dataset.ssQtyStep, 10);
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      if (input) input.addEventListener('change', render);
    });

    // packs (cantidad predefinida)
    $$('[data-ss-bundle]', root).forEach(function (bundle) {
      bundle.addEventListener('change', function () {
        var qtyInput = $('[data-ss-qty-input]', root);
        if (qtyInput) {
          qtyInput.value = bundle.value;
          render();
        }
      });
    });

    render();
    booted = true;
  }

  /* ---------- barra fija de compra ---------- */
  function initSticky() {
    var bar = $('[data-ss-sticky]');
    if (!bar || bar.dataset.ssReady) return;
    bar.dataset.ssReady = '1';
    var trigger = $('[data-ss-sticky-trigger]');
    if (!trigger || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 }).observe(trigger);

    var btn = $('[data-ss-sticky-submit]', bar);
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var form = $('[data-ss-product-form] form');
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  }

  /* ---------- cuenta atrás ---------- */
  function initCountdown(el) {
    if (el.dataset.ssReady) return;
    el.dataset.ssReady = '1';
    var hoursSpan = 24;
    var stored = null;
    try { stored = window.localStorage.getItem('ss_deadline'); } catch (e) {}
    var deadline = stored ? parseInt(stored, 10) : 0;
    if (!deadline || deadline < Date.now()) {
      deadline = Date.now() + hoursSpan * 3600 * 1000;
      try { window.localStorage.setItem('ss_deadline', String(deadline)); } catch (e) {}
    }
    function pad(n) { return n < 10 ? '0' + n : String(n); }

    // Los tres <b> se crean UNA vez. Antes cada tick reescribía innerHTML, o sea
    // que el navegador destruía y volvía a parsear tres elementos con fondo y
    // border-radius cada segundo, en todas las páginas, para siempre.
    el.textContent = '';
    var hh = document.createElement('b');
    var mm = document.createElement('b');
    var ss = document.createElement('b');
    el.appendChild(hh);
    el.appendChild(document.createTextNode(':'));
    el.appendChild(mm);
    el.appendChild(document.createTextNode(':'));
    el.appendChild(ss);

    function tick() {
      var left = Math.max(0, deadline - Date.now());
      var s = Math.floor(left / 1000);
      hh.textContent = pad(Math.floor(s / 3600));
      mm.textContent = pad(Math.floor((s % 3600) / 60));
      ss.textContent = pad(s % 60);
      if (left <= 0) {
        deadline = Date.now() + hoursSpan * 3600 * 1000;
        try { window.localStorage.setItem('ss_deadline', String(deadline)); } catch (e) {}
      }
    }

    var timer = null;
    function start() { if (!timer) { tick(); timer = setInterval(tick, 1000); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    // En una pestaña de fondo no hay nada que mirar: paramos el reloj del todo.
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') { stop(); } else { start(); }
    });
    start();
  }

  /* ---------- guía de tallas / diálogos ---------- */
  function initDialogs() {
    $$('[data-ss-dialog-open]').forEach(function (btn) {
      if (btn.dataset.ssReady) return;
      btn.dataset.ssReady = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var dlg = document.getElementById(btn.dataset.ssDialogOpen);
        if (dlg && dlg.showModal) dlg.showModal();
      });
    });
    $$('[data-ss-dialog-close]').forEach(function (btn) {
      if (btn.dataset.ssReady) return;
      btn.dataset.ssReady = '1';
      btn.addEventListener('click', function () { btn.closest('dialog').close(); });
    });
  }

  /* ---------- carrito: cantidad y eliminar ---------- */
  function initCart(root) {
    if (root.dataset.ssReady) return;
    root.dataset.ssReady = '1';
    $$('[data-ss-cart-qty]', root).forEach(function (wrap) {
      var input = $('input', wrap);
      $$('[data-ss-qty-step]', wrap).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.ssQtyStep, 10));
          input.value = next;
          root.querySelector('form').submit();
        });
      });
      input.addEventListener('change', function () { root.querySelector('form').submit(); });
    });
  }


  /* ---------- cabecera: cajón móvil y búsqueda ---------- */
  function initHeader() {
    var drawer = $('[data-ss-drawer]');
    if (drawer && !drawer.dataset.ssReady) {
      drawer.dataset.ssReady = '1';
      var lastFocus = null;

      function open() {
        lastFocus = document.activeElement;
        drawer.hidden = false;
        requestAnimationFrame(function () { drawer.classList.add('is-open'); });
        document.body.style.overflow = 'hidden';
        var first = drawer.querySelector('a, button');
        if (first) first.focus();
      }
      function close() {
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
        setTimeout(function () { drawer.hidden = true; }, 280);
        if (lastFocus) lastFocus.focus();
      }

      $$('[data-ss-drawer-open]').forEach(function (b) { b.addEventListener('click', open); });
      $$('[data-ss-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
      });
    }

    var panel = $('[data-ss-search-panel]');
    var toggle = $('[data-ss-search-toggle]');
    if (panel && toggle && !toggle.dataset.ssReady) {
      toggle.dataset.ssReady = '1';
      toggle.addEventListener('click', function () {
        var open = panel.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { var i = $('input', panel); if (i) i.focus(); }
      });
    }
  }

  /* ---------- imágenes: soltar la vista previa borrosa al cargar ----------
     El contenedor .ss-media enseña el color dominante y el LQIP (ss-lqip.css)
     como fondo, y la foto real se pinta encima. Lo único que hace el JS es
     quitar ese fondo base64 cuando ya no hace falta.

     Aquí NO se toca la opacidad de la imagen. Antes sí, para hacer un fundido,
     y eso significaba que si el evento load no llegaba la foto se quedaba
     invisible y el usuario veía el borroso de forma permanente. Si este JS no
     se ejecuta, lo peor que pasa es que el navegador retiene unos KB de base64. */
  function initMedia(ctx) {
    $$('.ss-media', ctx).forEach(function (box) {
      if (box.dataset.ssReady) return;
      box.dataset.ssReady = '1';
      var img = box.querySelector('img');
      if (!img) return;

      function done() { box.classList.add('is-loaded'); }

      /* `load` sólo dice que los bytes están; el mapa de bits puede tardar unos
         fotogramas más en decodificarse. Si quitamos la vista previa borrosa
         ahí, se ve un destello del color dominante antes de que aparezca la
         foto. decode() espera a que esté lista para pintar.
         Si falla, dejamos la vista previa puesta: ante una imagen rota es mejor
         un borroso que un rectángulo de color plano. */
      function ready() {
        if (typeof img.decode !== 'function') { done(); return; }
        img.decode().then(done, function () {});
      }

      if (img.complete && img.naturalWidth > 0) { ready(); return; }
      img.addEventListener('load', ready, { once: true });
    });
  }

  /* ---------- arranque ---------- */
  function boot(ctx) {
    initMedia(ctx);
    $$('[data-ss-gallery]', ctx).forEach(initGallery);
    $$('[data-ss-product-form]', ctx).forEach(initProductForm);
    $$('[data-ss-countdown]', ctx).forEach(initCountdown);
    $$('[data-ss-cart]', ctx).forEach(initCart);
    initSticky();
    initDialogs();
    initHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // Editor de temas de Shopify
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
